var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"badge badge-pill text-capitalize",style:({ backgroundColor: this.color(), color: 'white' })},[_vm._v(_vm._s(this.text()))])
}
var staticRenderFns = []

export { render, staticRenderFns }